/* HAVITA cart badge: reconcile totals without replacing the header or retrying adds. */
(() => {
  if (window.havitaCartCount) return;
  let revision = 0;
  let running = false;
  let timer;

  function render(count) {
    const previous = document.querySelector('[data-hv-cart-link] .hv-cart-count')?.textContent;
    document.querySelectorAll('[data-hv-cart-link]').forEach(link => {
      const badge = link.querySelector('.hv-cart-count');
      if (badge) {
        badge.textContent = String(count);
        badge.classList.toggle('is-empty', count === 0);
      }
      link.setAttribute('aria-label', `Cart, ${count} ${count === 1 ? 'item' : 'items'}`);
    });
    if (previous != null && Number(previous) !== count) {
      const status = document.querySelector('[data-hv-cart-status]');
      if (status) status.textContent = count === 0 ? 'Your bag is empty.' : `${count} ${count === 1 ? 'item' : 'items'} in your bag.`;
    }
  }

  async function reconcile() {
    if (running) return;
    running = true;
    const requestedRevision = revision;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json' }, signal: controller.signal
      });
      if (!response.ok) throw new Error('Cart count unavailable');
      const cart = await response.json();
      if (requestedRevision === revision && Number.isSafeInteger(cart.item_count) && cart.item_count >= 0) {
        render(cart.item_count);
      }
    } catch (_) {
      // Keep the last known count. A display error must never replay a successful add.
    } finally {
      clearTimeout(timeout);
      running = false;
      if (requestedRevision !== revision) schedule();
    }
  }

  function schedule() {
    revision += 1;
    clearTimeout(timer);
    timer = setTimeout(reconcile, 40);
  }

  window.havitaCartCount = { refresh: schedule };
  document.addEventListener('cart:update', schedule);
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) schedule();
  });
  window.addEventListener('pageshow', schedule);
  schedule();
})();
